/**
 * Validates that a string contains a valid email
 * @param {sting} email The email to validate
 */
export const isValidEmail = (email: string): boolean => {
  if (typeof email === 'string') {
    return new RegExp(/[a-zA-Z0-9._%+-]+@([a-zA-Z0-9-]+\.)+[a-zA-Z0-9-]{2,63}$/g).test(email);
  } else {
    return false;
  }
};

/**
 * Validates that a string is at least eight characters long and contains one uppercase, one lowercase and one special character.
 * @param pass The pass to validate
 */
export const isValidPass = (pass: string): boolean => {
  if (typeof pass === 'string') {
    return new RegExp(/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?([^\w\s]|[_])).{8,}$/).test(pass);
  } else {
    return false;
  }
};

export const isValidFilename = (filename: string): boolean => {
  if (typeof filename === 'string') {
    return !new RegExp(/[`*?|:+&#"<>\\/]/gi).test(filename);
  }
  return false;
};

/**
 * Validates that a string actually has an URL format
 * @param url The string the validate
 */
export const isValidURL = (url: string): boolean => {
  if (typeof url === 'string') {
    // taken from jquery validation plugin
    // https://github.com/jquery-validation/jquery-validation/blob/c1db10a34c0847c28a5bd30e3ee1117e137ca834/src/core.js#L1343
    // modified to accept URLs with our without http:// or ftp://
    return new RegExp(
      /^(?:(?:(?:https?|ftp):)?\/\/)?(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})).?)(?::\d{2,5})?(?:[/?#]\S*)?$/i
    ).test(url);
  }
  return false;
};

/**
 * Given a list of domains, check if an email has a domain in the list
 * @param email The email string
 * @param domainList The list of domains
 */
export const isEmailInDomainList = (email: string, domainList: string[]) => {
  if (isValidEmail(email)) {
    return domainList.some(domain => {
      const re = new RegExp(`@${domain}\\.`, 'g');
      return re.test(email);
    });
  } else {
    return false;
  }
};
